export default __webpack_public_path__ + "static/media/icn-driver-predictability.2158adfd.svg";